import { render } from "./ChordTable.vue?vue&type=template&id=1168df6c&scoped=true"
import script from "./ChordTable.vue?vue&type=script&lang=js"
export * from "./ChordTable.vue?vue&type=script&lang=js"

import "./ChordTable.vue?vue&type=style&index=0&id=1168df6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1168df6c"]])

export default __exports__